export const getPublicProfileUrl = (id?: number | string) => {
  return `${window.location.protocol}//${window.location.host}/path/user/${id}`;
};
